export default __webpack_public_path__ + "static/media/serpentines_3.b5343d73.png";